import { defineRecipe as a } from "@pandacss/dev";
const o = a({
  className: "property-badge",
  base: {
    color: "text-white!"
  },
  defaultVariants: {
    variant: "published"
  },
  variants: {
    variant: {
      published: {
        backgroundColor: "bg-success-solid_alt"
      },
      in_review: {
        backgroundColor: "bg-warning-solid_alt"
      },
      rejected: {
        backgroundColor: "bg-error-solid"
      },
      delisted: {
        backgroundColor: "alpha-black-30"
      },
      archived: {
        backgroundColor: "alpha-black-30"
      }
    }
  }
});
export {
  o as propertyBadge
};
